export interface IColumn {
  id?: string | number;
  title: string;
  name?: string;
  index?: number;
  type?: number;
  orderId?: number;
  allowableValues?: string[];
  normalCase?: boolean;
}
